import { render, staticRenderFns } from "./common-service.vue?vue&type=template&id=2d5e535a&scoped=true"
import script from "./common-service.vue?vue&type=script&lang=js"
export * from "./common-service.vue?vue&type=script&lang=js"
import style0 from "./common-service.vue?vue&type=style&index=0&id=2d5e535a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e535a",
  null
  
)

export default component.exports